export const ERRORS = {
  required: 'Campo obrigatório',
  to_large: 'Muito grande',
  to_short: 'Muito pequeno',
  invalid_email: 'E-mail inválido',
  invalid_cpf: 'CPF inválido'
};
